
import VRuntimeTemplate from 'v-runtime-template'
import { initialiserComponents, langue } from '~/assets/js/utiles.js'
import { initialiserTableauResponsive } from '../../../assets/js/utiles'

export default {
  components: {
    VRuntimeTemplate
  },
  async asyncData ({ params, error, app, store, $directus }) {
    const localeCourant = app.i18n.locale
    const langueCourante = langue(localeCourant)
    const sousSection = params.soussection

    const collectionSousSection = $directus.items('sous_section')

    const resultats = await collectionSousSection.readByQuery({
      fields: [
        'translations.languages_code',
        'translations.titre',
        'translations.url',
        'translations.contenu',
        'pages.icone',
        'pages.translations.titre',
        'pages.translations.url',
        'section.bloc_entete.espace_conseillers',
        'section.bloc_entete.image.couleur_de_fond',
        'section.bloc_entete.image.image.id',
        'section.prefooter.est_pygma',
        'section.prefooter.image.couleur_de_fond',
        'section.prefooter.image.image.id',
        'section.prefooter.translations.texte',
        'section.translations.languages_code',
        'section.translations.titre',
        'section.translations.url'
      ],
      filter: {
        translations: {
          url: {
            _eq: sousSection
          },
          languages_code: {
            _eq: langueCourante
          }
        }
      },
      deep: {
        section: {
          prefooter: {
            translations: {
              _filter: {
                languages_code: {
                  _eq: langueCourante
                }
              }
            }
          }
        },
        pages: {
          _filter: {
            active: {
              _eq: 1
            }
          },
          translations: {
            _filter: {
              languages_code: {
                _eq: langueCourante
              }
            }
          }
        }
      },
      limit: -1
    })

    if (resultats.data.length === 0) return error({ statusCode: 404, message: 'Page introuvable' })

    let sectionCourante = null
    let sousSectionCourante = null
    let listePages = null
    let prefooter = null
    let blocEntete = null

    const contenuSousSection = resultats.data[0]
    prefooter = contenuSousSection.section.prefooter
    blocEntete = contenuSousSection.section.bloc_entete

    const paramUrlSelonLangue = {
      fr: {
        section: null,
        soussection: null
      },
      en: {
        section: null,
        soussection: null
      }
    }

    for (const traductionSousSection of contenuSousSection.translations) {
      const langueTraduction = traductionSousSection.languages_code.split('-')[0]
      if (langueTraduction === localeCourant) {
        sousSectionCourante = traductionSousSection
        if (sousSectionCourante.contenu) {
          sousSectionCourante.contenu = `<div> ${initialiserComponents(sousSectionCourante.contenu)} </div>`
        }
      }
      paramUrlSelonLangue[langueTraduction].soussection = traductionSousSection.url
    }

    for (const traductionSection of contenuSousSection.section.translations) {
      const langueTraduction = traductionSection.languages_code.split('-')[0]
      if (langueTraduction === localeCourant) {
        sectionCourante = traductionSection
      }
      paramUrlSelonLangue[langueTraduction].section = traductionSection.url
    }

    const urlSelonLangue = (langue) => {
      return ('/' + paramUrlSelonLangue[langue].section +
        '/' + paramUrlSelonLangue[langue].soussection + '/'
      )
    }

    listePages = []
    for (const page of contenuSousSection.pages) {
      const contenuPage = page.translations[0]
      const urlPage = urlSelonLangue(localeCourant) + contenuPage.url
      contenuPage.url = urlPage
      contenuPage.icone = page.icone
      listePages.push(contenuPage)
    }

    // On met à jour les paramètres de route dans le vuex pour que l'application
    // sache le nom de la page dans toute les langues.
    await store.dispatch('i18n/setRouteParams', paramUrlSelonLangue)

    return {
      section: sectionCourante,
      sousSection: sousSectionCourante,
      pages: listePages,
      prefooter: prefooter,
      blocEntete: blocEntete
    }
  },
  mounted: function () {
    this.$nextTick(initialiserTableauResponsive())
  },
  head () {
    const i18nHeaders = this.$nuxtI18nHead({ addSeoAttributes: true })

    return {
      title: `service régional d'admission du montréal métropolitain - ${this.sousSection.titre}`,
      htmlAttrs: {
        ...i18nHeaders.htmlAttrs
      },
      meta: [
        { hid: 'description', name: 'description', content: this.$t('description_seo') },
        ...i18nHeaders.meta
      ],
      link: [
        ...i18nHeaders.link
      ]
    }
  }
}
